"use client";

import { getCookie, setCookie } from "cookies-next";

const TZ_COOKIE = "client_tz_dot";

/**
 * Get timezone from cookie or detect it
 */
export const getClientTimezone = (): string => {
    try {
        // 1️⃣ Check cookie
        const existing = getCookie(TZ_COOKIE) as string;

        if (existing) {
            return existing;
        }

        // 2️⃣ Detect from browser
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // 3️⃣ Store cookie (long-term)
        setCookie(TZ_COOKIE, tz, {
            path: "/",
            maxAge: 60 * 60 * 24 * 365 * 5, // 5 years
            sameSite: "lax",
        });

        return tz;
    } catch (error) {
        console.error("Timezone detection failed:", error);

        // 4️⃣ Fallback
        const fallback = "UTC";

        setCookie(TZ_COOKIE, fallback, {
            path: "/",
            maxAge: 60 * 60 * 24 * 365 * 5,
        });

        return fallback;
    }
};